<template>
    <div class="banner">
        <div class="controller">
            <!-- left  -->
            <button @click="prevSlide">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                </svg>
            </button>
            <!-- right  -->
            <button  @click="nextSlide">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                </svg>

            </button>
        </div>

        <div class="container" ref="track">
            
            <!-- tiggo 4 -->
            <div class="card">
                <div>
                    <img src="../../assets/slider-img3.webp" alt="tiggo-4 img" />
                </div>
                <footer>
                    <img src="../../assets//logos/tiggo-4.png" alt="tiggo-4 logo">
                    <p>cross wonderful life</p>
                </footer>
            </div>
            
            <!-- himla -->
            <div class="card">
                <div>
                    <video
                        poster="../../assets/himla-video.mp4"
                        autoplay
                        muted
                        loop
                        playsinline
                        webkit-playsinline="true"
                        x5-video-player-type="h5"
                        x5-video-player-fullscreen="true"
                        data-src="../../assets/himla.mp4"
                        src="../../assets/himla-video.mp4"
                    ></video>
                </div>
                <footer>
                    <img src="../../assets//logos/himla.png" alt="himla logo" />
                    <p>master the terrain</p>
                    
                </footer>
            </div>

            <!-- tiggo 7 -->
            <div class="card">
                <div>
                    <img src="../../assets/slider-img2.webp" alt="tiggo-7 img" />
                </div>
                <footer>
                    <img src="../../assets/logos/tiggo-7.png" style="width: 70%;" alt="tiggo-7 logo" />
                    <p>all the way with you</p>
                </footer>
            </div>
            
            <!-- tiggo 4 -->
            <div class="card">
                <div>
                    <img src="../../assets/slider-img3.webp" alt="tiggo-4 img" />
                </div>
                <footer>
                    <img src="../../assets//logos/tiggo-4.png" alt="tiggo-4 logo">
                    <p>cross wonderful life</p>
                </footer>
            </div>
            
        </div>

    </div>
</template>

<script>
    export default {
  data() {
    return {
      index: 0,
      total: 3,
      timer: null
    };
  },

  methods: {
    update() {
      this.$refs.track.style.transform =
        `translateX(-${this.index * 100}vw)`;
    },

    nextSlide() {
      this.reset();
      this.index = (this.index + 1) % this.total;
      this.update();
    },

    prevSlide() {
      this.reset();
      this.index = (this.index - 1 + this.total) % this.total;
      this.update();
    },

    auto() {
      this.timer = setInterval(() => {
        this.index = (this.index + 1) % this.total;
        this.update();
      }, 5000);
    },

    reset() {
      clearInterval(this.timer);
      this.auto();
    }
  },

  mounted() {
    this.auto();
  },

  beforeDestroy() {
    clearInterval(this.timer);
  }
};

</script>